export default "__VITE_ASSET__JQQZljdz__"